import InsuranceWizard from './InsuranceWizard';

export default InsuranceWizard;
